module.exports = __webpack_public_path__ + "static/media/lower_case.0d953332.svg";